module.exports = __webpack_public_path__ + "media/images/haircut/weinie@3x-4520a19f31074f000353d06bccced627.jpg";